import { type Writable, writable } from 'svelte/store';

export const loginOverlayIsVisible = writable(false);

export const items = ['Login', 'Registrieren'] as const;
export const activeItem: Writable<(typeof items)[number]> = writable(items[0]);

export const height = writable(0);
